<template>
	<div id="StepWizardWhatsapp" class="text-left">
		<div class="title-area">
			<h4 v-if="getWhatsappConfig">Chat WhatsApp</h4>
			<h4 v-else>Telefone para Suporte</h4>
			<p v-if="getWhatsappConfig">
				Uma integração massa no seu site para gerar mais vendas 👊
			</p>
			<p v-else>
				Nos fale um telefone para que a gente consiga entrar em contato
				caso precise entrar em suporte.
			</p>
			<p class="text-center mt-4">
				<img
					style="height: 159px"
					src="/static/img/custon_whatsapp.png"
				/>
			</p>
		</div>
		<div class="input-area">
			<div class="row">
				<div class="col-12">
					<label>Qual seu WhatsApp?</label>
				</div>
				<div class="col-4 col-md-3">
					<Country @getCountry="getCountry($event)"></Country>
				</div>
				<div class="col">
					<the-mask
						v-if="whatsappIdd == 30"
						type="tel"
						class="form-control hide-placeholder"
						:mask="['(##) ####-####', '(##) #####-####']"
						placeholder="DDD + número"
						v-model="whatsappNumber"
					/>
					<input
						v-else
						type="tel"
						class="form-control hide-placeholder"
						placeholder="DDD + número"
						v-model="whatsappNumber"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import Country from "@/components/Country";
	export default {
		name: "StepWizardWhatsapp",
		data() {
			return {
				maskPhone: "",
				whatsappNumber: "",
				whatsappIdd: 30,
			};
		},
		components: {
			Country,
		},
		created() {
			this.whatsappNumber = this.$store.state.wizard.dataSite.whatsappNumber;
			if (this.$store.state.wizard.dataSite.whatsappIdd) {
				this.whatsappIdd = this.$store.state.wizard.dataSite.whatsappIdd;
			}
		},
		mounted() {
			this.$emit("updateStep");
			this.$store.dispatch("WIZARD_BLOCK_NEXT", [false]);
			this.$store.dispatch("WIZARD_SHOW_SKIP", [true]);
		},
		computed: {
			getWhatsappConfig() {
				return this.$store.state.wizard.dataSite.contactSetup.showWhatsapp;
			},
		},
		methods: {
			updateWhatsapp() {
				this.$store.dispatch("WIZARD_WHATSAPP_NUMBER", [
					this.whatsappNumber,
				]);
			},
			saveWhatsapp() {
				let whats = {
					whatsappIdd: this.whatsappIdd,
					whatsappNumber: this.whatsappNumber,
				};
				let token = this.$session.get("jwt");
				let siteId = this.$session.get("siteId");
				axios({
					method: "post",
					url:
						process.env.ROOT_API +
						"api/site/" +
						siteId +
						"/wizard/whatsapp/update",
					data: whats,
					headers: {
						Authorization: "Bearer " + token,
						// 'Content-Type': 'application/x-www-form-urlencoded'
					},
				}).then((response) => {});
			},
			getCountry(event) {
				this.whatsappIdd = event;
				this.$store.dispatch("WIZARD_WHATSAPP_IDD", [this.whatsappIdd]);
			},
		},
		destroyed() {
			this.saveWhatsapp();
			this.updateWhatsapp();
		},
	};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/organisms/StepWizardWhatsapp.vue